module.exports = __webpack_public_path__ + "static/img/map.4392dab.png";


//////////////////
// WEBPACK FOOTER
// ./static/map.png
// module id = duwu
// module chunks = 1